import { Provider } from '@angular/core';
import { API_URL } from '@core/tokens/api-url.token';
import { environment } from '../../../environments/environment';

export const API_URL_PROVIDER: Provider = {
	provide: API_URL,
	useValue: environment.baseUrl,
};
